module.exports = __webpack_public_path__ + "img/logo.29b54288.png";